import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-control-errors',
  templateUrl: './control-errors.component.html',
  styleUrls: ['./control-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ControlErrorsComponent implements OnInit {

  _text: string | number | boolean;
  _hide = true;

  @Input() set text(value: string | number | boolean) {
    if (value !== this._text) {
      this._text = value;
      this._hide = !value;
      this.cdr.detectChanges();
    }
  };

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {}

}
